import { render, staticRenderFns } from "./AdminCoreCauseDetail.vue?vue&type=template&id=5a539e39&scoped=true"
import script from "./AdminCoreCauseDetail.vue?vue&type=script&lang=js"
export * from "./AdminCoreCauseDetail.vue?vue&type=script&lang=js"
import style0 from "./AdminCoreCauseDetail.vue?vue&type=style&index=0&id=5a539e39&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a539e39",
  null
  
)

export default component.exports